import type { ReactNode } from 'react';

import { CopyToClipboardButton } from '@molecules/CopyToClipboardButton';

type Props = {
  label: string;
  children: ReactNode;

  copyText?: string | null;
  copyFallbackText?: string;
};

export const UserDetailsLabel = ({
  label,
  children,
  copyText,
  copyFallbackText
}: Props) => {
  const isCopyEnabled = copyText !== undefined;

  const content = (
    <span className="inline-block max-w-[250px] truncate">{children}</span>
  );

  return (
    <div>
      <div className="text-sm text-content-secondary">{label}</div>

      <div className="text-wrap font-medium">
        {isCopyEnabled ? (
          <CopyToClipboardButton
            text={copyText}
            displayText={content}
            fallbackText={copyFallbackText}
          />
        ) : (
          content
        )}
      </div>
    </div>
  );
};
